export default __webpack_public_path__ + "static/media/Logo_WHITE-01.98420918.svg";